import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import ClayLayout from '@clayui/layout';
import {
    businessProfileDetails,
    dubaiMarketDetails,
    scopeKey
} from '../../../config';
import FormComponent from '../../../generic-components/formComponent/FormComponent';
import CutButton from '../../../generic-components/customCutButton/CutButton';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { ClayCheckbox } from '@clayui/form';
import { useDropDownMutation } from '../../../apis/useDropDownMutation';
import { processUploadedFiles } from '../../../utils/FileToBase64';
import { toast } from 'react-toastify';
import {
    useApiAuthMutationDynamic,
    useApiMutation,
    useApiMutation2
} from '../../../apis/useApi';
import { createUser } from '../../../apis/apiClient';
import { getDecodedQueryParam } from '../../../utils/commanUtil';

const BusinessInformationForm: React.FC<{
    setStep: React.Dispatch<React.SetStateAction<number>>;
    formData: { [key: string]: any };
    setFormData: (name: string, value: any) => void;
    setResStatusCode: React.Dispatch<React.SetStateAction<number>>;
    setResStatusMessage: React.Dispatch<React.SetStateAction<string>>;
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({
    setStep,
    setFormData,
    formData,
    setResStatusCode,
    setResStatusMessage,
    setIsLoading
}) => {
    const queryParams: any = getDecodedQueryParam();
    const {
        control,
        register,
        formState: { errors: formErrors },
        watch,
        handleSubmit,
        setError,
        setValue,
        formState: { errors }
    } = useForm({ mode: 'all' });
    const [checked, setChecked] = useState(false);
    const getTechBusinessIndustry = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_TECH_BUSINESS_INDUSTRY`
    );
    const getIndustryVertical = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_INDUSTRY_VERTICAL`
    );
    const getNumberOfEmployees = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_NUMBER_OF_EMPLOYEES`
    );
    const getAnnualRevenue = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_REQUESTOR_ANNUAL_REVENUE`
    );
    const getCurrentBusinessValuation = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_REQUESTOR_CURRENT_BUSINESS_VALUATION`
    );
    const getCompanyCurrentFundingStage = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_REQUESTOR_COMPANY_CURRENT_FUNDING_STAGE`
    );
    const getPastCollaborationAndClientSize = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_REQUESTOR_PAST_COLLAB_SIZE`
    );
    const getTodaySell = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_REQUESTOR_TODAYS_DUBAI_SELL`
    );
    const getReachedOutInPast = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_REQUESTOR_REACHED_OUT_THEM_IN_PAST`
    );
    const getCategoriesToBeConnected = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_REQUESTOR_WANTED_CATEGORIES_TO_BE_CONNECTED`
    );
    const getReadyToOpenCompany = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_HOW_REQUESTOR_READY_TO_OPEN_COMPANY`
    );
    const getBiggestChallanges = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_REQUESTOR_BIGGEST_CHALLANGES`
    );
    const getBusinessModelType = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_BUSINESS_MODEL_TYPE`
    );
    const getCountryList = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_COUNTRY`
    );
    const getTechnologyReadiness = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_EXPECTED_TECH_READINESS`
    );


    const industryVertical = watch('requestorIndustryVertical');
    const requestorCompanyCurrentFundingStage = watch(
        'requestorCompanyCurrentFundingStage'
    );
    const businessModelType = watch('requestorBusinessModelType');

    const todaysSellInDubaiOrUAE = watch(
        'requestorAnswerForTodaysSellInDubaiOrUAE'
    );
    const reachedOutThemInPast = watch('requestorReachedOutThemInPast');
    const categoriesToBeConnected = watch(
        'requestorWantedCategoriesToBeConnected'
    );
    const areReadyToOpenCompany = watch('howRequestorAreReadyToOpenCompany');
    const biggestChallangesInUAEStratup = watch(
        'requestorBiggestChallangesInUAEStratup'
    );

    const allFields = [...businessProfileDetails, ...dubaiMarketDetails];
    const { businessInformationDetails } = useSelector(
        (state: RootState) => state.basicInformationSlice
    );
    const { basicInformationDetails } = useSelector(
        (state: RootState) => state.basicInformationSlice
    );
    const [corporatePresentation, setCorporatePresentation] = useState<File[]>(
        []
    );

    useEffect(() => {
        if (formData['corporatePresentation'] !== corporatePresentation) {
            setFormData('corporatePresentation', corporatePresentation);
        }
    }, [corporatePresentation]);

    useEffect(() => {
        if (
            basicInformationDetails.registeredCompanyEmiratesReference ===
            'dubai'
        ) {
            setValue(
                'howRequestorAreReadyToOpenCompany',
                'weAlreadyHaveAnEntityInDubai'
            );
        }
    }, [basicInformationDetails.registeredCompanyEmiratesReference]);

    useEffect(() => {
        const subscription = watch((value, { name }) => {
            if (name && name !== 'corporatePresentation') {
                const newValue = value[name];
                if (formData[name] !== newValue) {
                    setFormData(name, newValue);
                }
            }
        });
        return () => subscription.unsubscribe();
    }, [watch, formData, setFormData]);

    const fileHandling = {
        corporatePresentation: {
            selectedFiles: corporatePresentation,
            setSelectedFiles: setCorporatePresentation
        }
    };
    const dropdownOptions: any = {
        requestorTechBusinessIndustrySector: getTechBusinessIndustry,
        requestorIndustryVertical: getIndustryVertical,
        numberOfEmployees: getNumberOfEmployees,
        requestorAnnualRevenue: getAnnualRevenue,
        requestorCurrentBusinessValuation: getCurrentBusinessValuation,
        requestorCompanyCurrentFundingStage: getCompanyCurrentFundingStage,
        requestorOutsideHeadquarterCountires: getCountryList,
        requestorPastCollaborationAndClientSize:
            getPastCollaborationAndClientSize,
        requestorAnswerForTodaysSellInDubaiOrUAE: getTodaySell,
        requestorReachedOutThemInPast: getReachedOutInPast,
        requestorWantedCategoriesToBeConnected: getCategoriesToBeConnected,
        howRequestorAreReadyToOpenCompany: getReadyToOpenCompany,
        requestorBiggestChallangesInUAEStratup: getBiggestChallanges,
        requestorBusinessModelType: getBusinessModelType,
        productTechnologyReadiness: getTechnologyReadiness
    };

    const createMatchMakinRequestWithToken = useApiAuthMutationDynamic<any, {}>(
        `/o/c/matchmakingrequestors/scopes/${encodeURIComponent(scopeKey)}`,
        'post',
        {
            onSuccess: async (data) => {
                toast.success('Form Submitted Successfully', {
                    theme: 'light',
                    autoClose: 2000
                });

                setIsLoading(false);
                setResStatusCode(200);
                setResStatusMessage('User Created Successfully');
                setStep(3);
            },
            onError: (error: any) => {
                if (error?.response?.status == 400) {
                    toast.error(error?.response?.data?.title, {
                        theme: 'light',
                        autoClose: 2000
                    });
                }
                setResStatusCode(500);
                setResStatusMessage(
                    error?.response?.data?.title ?? 'Something went wrong'
                );
                setStep(3);
                console.error('Mutation error:', error);
                setIsLoading(false);
            }
        }
    );

    const getOtpToken = useApiMutation2<
        { access_token: string },
        { grant_type: string; client_id: string; client_secret: string }
    >('o/oauth2/token', 'post');

    const onSubmit = async (data: any) => {
        setIsLoading(true);

        try {
            // Process uploaded files
            const corporatePresentationFiles = corporatePresentation || [];
            let allAttachments: any[] = [];
            if (corporatePresentation?.length) {
                await Promise.all(
                    corporatePresentation.map(async (item: any) => {
                        if (item instanceof File) {
                            const doc = await processUploadedFiles(
                                corporatePresentationFiles
                            );
                            allAttachments.push(doc[0]);
                        }
                    })
                );
            }
            const basicInfo = {
                ...basicInformationDetails,
                requestorFirstName: basicInformationDetails?.contactFirstName,
                requestorLastName: basicInformationDetails?.contactLastName,
                requestorWorkEmail: basicInformationDetails?.contactWorkEmail
            };

            let payload = {
                ...basicInfo,
                // FIXME: change static value to dynamic
                requestorArrivalReference: queryParams?.eventId
                    ? { name: 'By EPD', key: 'byEPD' }
                    : { name: 'By Site', key: 'bySite' },
                eventId: Number(queryParams?.eventId) || null,
                requestorTechBusinessIndustrySector:
                    data?.requestorTechBusinessIndustrySector,
                requestorIndustryVertical: data?.requestorIndustryVertical,
                numberOfEmployees: data?.numberOfEmployees,
                requestorBusinessModelType: data?.requestorBusinessModelType,
                requestorAnnualRevenue: data?.requestorAnnualRevenue,
                requestorCurrentBusinessValuation:
                    data?.requestorCurrentBusinessValuation,
                requestorCompanyCurrentFundingStage:
                    data?.requestorCompanyCurrentFundingStage,
                requestorOutsideHeadquarterCountires:
                    data?.requestorOutsideHeadquarterCountires,
                requestorPastCollaborationAndClientSize:
                    data?.requestorPastCollaborationAndClientSize,
                requestorClientsListKey: data?.requestorClientsListKey,
                requestorAnswerForTodaysSellInDubaiOrUAE:
                    data?.requestorAnswerForTodaysSellInDubaiOrUAE,
                introduceRequestorSpecificEntitiesInDubai:
                    data?.introduceRequestorSpecificEntitiesInDubai,
                requestorReachedOutThemInPast:
                    data?.requestorReachedOutThemInPast,
                requestorWantedCategoriesToBeConnected:
                    data?.requestorWantedCategoriesToBeConnected,
                howRequestorAreReadyToOpenCompany:
                    data?.howRequestorAreReadyToOpenCompany,
                requestorBiggestChallangesInUAEStratup:
                    data?.requestorBiggestChallangesInUAEStratup,
                requestorBusinessExplanation:
                    data?.requestorBusinessExplanation ?? '',
                productTechnologyReadiness:
                    data?.productTechnologyReadiness || '',

                otherIndustryVertical: data?.otherIndustryVertical ?? '',
                otherCompanyCurrentFundingStage:
                    data?.otherCompanyCurrentFundingStage ?? '',
                otherTypeOfBusinessModel: data?.otherTypeOfBusinessModel ?? '',
                otherAnswerForTodaySell: data?.otherAnswerForTodaySell ?? '',
                otherSpecificationForReachedOut:
                    data?.otherSpecificationForReachedOut ?? '',
                otherCategoriesWantedToConnectInDubai:
                    data?.otherCategoriesWantedToConnectInDubai ?? '',
                otherAnswerForDubaiStartup:
                    data?.otherAnswerForDubaiStartup ?? '',
                otherAnswerForChallanges: data?.otherAnswerForChallanges ?? '',
                matchmakingToAttachment: allAttachments
            };


            // ✅ Get OTP Token
            const tokenResponse = await getOtpToken.mutateAsync({
                data: {
                    grant_type: 'client_credentials',
                    client_id: 'id-e18bb565-c75a-2b97-9b72-45182297b8bf',
                    client_secret: 'secret-38c64dc5-99cf-2d36-a59b-1bee3688b78'
                }
            });

            if (!tokenResponse?.access_token) {
                throw new Error('Failed to get OTP token');
            }

              const userResponse = await createUser({
                  emailAddress:
                      basicInformationDetails?.contactWorkEmail?.trim(),
                  givenName: basicInformationDetails?.contactFirstName.trim(),
                  familyName: basicInformationDetails?.contactLastName.trim(),
                  userAccountContactInformation: {
                      telephones: [
                          {
                              phoneNumber:
                                  basicInformationDetails?.requestorMobileNumber?.trim(),
                              phoneType: 'business',
                              primary: true
                          }
                      ]
                  }
              });

                if ([201, 200].includes(userResponse?.data?.statusCode)) {
                    await createMatchMakinRequestWithToken.mutateAsync({
                        data: payload,
                        token: tokenResponse.access_token
                    });
                } else {
                    setIsLoading(false);
                    setResStatusCode(500);
                    setResStatusMessage('User Creation Failed');
                    setStep(3);
                }
        } catch (error: any) {
            console.error('Form Submission Error:', error);

            toast.error(
                error?.response?.data?.title ||
                    error.message ||
                    'Something went wrong',
                {
                    theme: 'light',
                    autoClose: 2000
                }
            );

            setResStatusCode(error?.response?.status || 500);
            setResStatusMessage(
                error?.response?.data?.title ||
                    error.message ||
                    'Something went wrong'
            );
            setStep(3);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        Object.entries(businessInformationDetails).forEach(([key, value]) => {
            if (key == 'corporatePresentation') {
                setCorporatePresentation(value);
                setValue(key, value);
            } else {
                setValue(key, value);
            }
        });
    }, [businessInformationDetails]);

    const newBusinessProfileDetails = businessProfileDetails?.filter(
        (field) => {
            if (field?.name == 'otherIndustryVertical')
                return industryVertical == 'others';
            if (field?.name == 'otherCompanyCurrentFundingStage') {
                return (
                    requestorCompanyCurrentFundingStage ==
                    'weHaveReceivedFundingThroughAlternativeMeansPleaseSpecify'
                );
            } else if (field?.name == 'otherTypeOfBusinessModel')
                return businessModelType == 'others';
            return true;
        }
    );

    const newdubaiMarketDetails = dubaiMarketDetails?.filter((field) => {
        if (field?.name == 'otherAnswerForTodaySell')
            return todaysSellInDubaiOrUAE == 'other';
        else if (field?.name == 'otherSpecificationForReachedOut')
            return reachedOutThemInPast == 'other';
        else if (field?.name == 'otherCategoriesWantedToConnectInDubai')
            return categoriesToBeConnected?.includes('others');
        else if (field?.name == 'otherAnswerForDubaiStartup')
            return areReadyToOpenCompany == 'other';
        else if (field?.name == 'otherAnswerForChallanges')
            return biggestChallangesInUAEStratup?.includes('other');
        return true;
    });

    useEffect(() => {
        if (industryVertical && industryVertical !== 'others')
            setValue('otherIndustryVertical', '');
        if (businessModelType && businessModelType !== 'others')
            setValue('otherTypeOfBusinessModel', '');
        if (todaysSellInDubaiOrUAE && todaysSellInDubaiOrUAE !== 'other')
            setValue('otherAnswerForTodaySell', '');
        if (reachedOutThemInPast && reachedOutThemInPast !== 'other')
            setValue('otherSpecificationForReachedOut', '');
        if (
            categoriesToBeConnected &&
            !categoriesToBeConnected?.includes('others')
        )
            setValue('otherCategoriesWantedToConnectInDubai', '');
        if (areReadyToOpenCompany && areReadyToOpenCompany !== 'other')
            setValue('otherAnswerForDubaiStartup', '');
        if (
            biggestChallangesInUAEStratup &&
            !biggestChallangesInUAEStratup?.includes('other')
        )
            setValue('otherAnswerForChallanges', '');
        if (
            requestorCompanyCurrentFundingStage &&
            requestorCompanyCurrentFundingStage !==
                'weHaveReceivedFundingThroughAlternativeMeansPleaseSpecify'
        )
            setValue('otherCompanyCurrentFundingStage', '');
    }, [
        industryVertical,
        businessModelType,
        todaysSellInDubaiOrUAE,
        categoriesToBeConnected,
        areReadyToOpenCompany,
        biggestChallangesInUAEStratup,
        requestorCompanyCurrentFundingStage
    ]);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="card-body p-0 pr-2 pl-2 personal-info-height">
                <div className="customer-title-container">
                    <h1 className="customer-title px-0 m-0">
                        Business Profile
                    </h1>
                    <div className="ib-hr"></div>
                </div>
                <div className="pt-4">
                    <ClayLayout.Row justify="start" className="content-gap">
                        {newBusinessProfileDetails?.map((data) => {
                            const colSize =
                                data?.name == 'requestorClientsListKey'
                                    ? 12
                                    : 6;
                            return (
                                <ClayLayout.Col
                                    key={data.name}
                                    xl={colSize}
                                    lg={colSize}
                                    md={colSize}
                                    sm={colSize}
                                    xs={colSize}
                                >
                                    <FormComponent
                                        isPartnerType={true}
                                        placeholder={data.placeholder}
                                        label={data.label}
                                        name={data.name}
                                        register={register}
                                        type={data.type}
                                        control={control}
                                        errors={formErrors}
                                        watch={watch}
                                        setError={setError}
                                        errorTitle={data.errorMessage}
                                        options={dropdownOptions[data.name]}
                                        required={data.required}
                                        component={
                                            data.component as
                                                | 'input'
                                                | 'textarea'
                                                | undefined
                                        }
                                        selectedFiles={
                                            fileHandling[
                                                data.name as keyof typeof fileHandling
                                            ]?.selectedFiles
                                        }
                                        setSelectedFiles={
                                            fileHandling[
                                                data.name as keyof typeof fileHandling
                                            ]?.setSelectedFiles
                                        }
                                    />
                                </ClayLayout.Col>
                            );
                        })}
                    </ClayLayout.Row>
                </div>
                <div className="customer-title-container">
                    <h1 className="customer-title px-0 m-0">Dubai Market</h1>
                    <div className="ib-hr"></div>
                </div>
                <div className="pt-4">
                    <ClayLayout.Row justify="start" className="content-gap">
                        {newdubaiMarketDetails?.map((data) => {
                            const colSize =
                                data?.name == 'requestorBusinessExplanation'
                                    ? 12
                                    : 6;
                            return (
                                <ClayLayout.Col
                                    key={data.name}
                                    xl={colSize}
                                    lg={colSize}
                                    md={colSize}
                                    sm={colSize}
                                    xs={colSize}
                                >
                                    <FormComponent
                                        isPartnerType={true}
                                        placeholder={data.placeholder}
                                        label={data.label}
                                        name={data.name}
                                        register={register}
                                        type={data.type}
                                        control={control}
                                        errors={formErrors}
                                        watch={watch}
                                        setError={setError}
                                        errorTitle={data.errorMessage}
                                        options={dropdownOptions[data.name]}
                                        required={data.required}
                                        component={
                                            data.component as
                                                | 'input'
                                                | 'textarea'
                                                | undefined
                                        }
                                    />
                                </ClayLayout.Col>
                            );
                        })}
                    </ClayLayout.Row>
                </div>
                <div className="custom-checkbox-container">
                    <ClayCheckbox
                        checked={checked}
                        className="custom-checkbox"
                        onChange={() => setChecked(!checked)}
                        label="By submitting this form, you acknowledge that the information, personal data and documents provided are correct, and you consent to share them with relevant third parties to use and facilitate collaborations and partnerships for the purposes of the program."
                    />
                </div>
            </div>
            <div className="button_container mt-4 d-flex justify-content-center">
                <CutButton
                    title="Submit"
                    buttonType="submit"
                    disabled={!checked}
                />
            </div>
        </form>
    );
};

export default BusinessInformationForm;
